const mixins = {
  methods: {
    formatDateDiff: function(dateStr) {
      var now = new Date()
      var createTime = new Date(dateStr)
      var diff = Math.floor((now - createTime) / (1000 * 3600 * 24))
      if (diff == 0) {
        return 'dnes'
      } else {
        return '- ' + diff + 'd'
      }
    },
    notEmpty: function(val) {
      if (typeof val === 'undefined' || val === null || val === '') {
        return false 
      } else {
        return true
      }
    }
  }
}
export default mixins
